export default {
  FirmListServiceInterface: Symbol('FirmListServiceInterface'),
  FirmUpdateServiceInterface: Symbol('FirmUpdateServiceInterface'),
};
